import styled from "styled-components";

export const Card = styled.article`
    display: flex;
    flex-direction: column;

    background: rgba(255, 255, 255, .03);

    border: 1px solid rgba(255, 255, 255, .08);
    border-radius: 24px;

    overflow: hidden;

    transition:
        transform .3s ease,
        border-color .3s ease,
        box-shadow .3s ease;

    &:hover {
        transform: translateY(-8px);

        border-color: ${({ theme }) => theme.colors.primary};

        box-shadow: 0 20px 50px rgba(0,0,0,.25);
    }
`;

export const Image = styled.img`
    width: 100%;
    height: 230px;

    object-fit: cover;

    display: block;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;

    gap: 1.25rem;

    padding: 2rem;
`;

export const Title = styled.h3`
    font-size: 1.5rem;
    font-weight: 700;

    color: ${({ theme }) => theme.colors.white};
`;

export const Description = styled.p`
    color: rgba(255, 255, 255, .75);

    line-height: 1.8;
`;

export const Features = styled.span`
    display: flex;
    flex-wrap: wrap;

    gap: .75rem;
`;

export const Feature = styled.span`
    padding: .45rem 1rem;

    border-radius: 999px;

    background: rgba(127, 191, 208, .12);

    border: 1px solid rgba(127, 191, 208, .35);

    color: ${({ theme }) => theme.colors.primary};

    font-size: .85rem;
    font-weight: 500;
`;

export const Footer = styled.div`
    margin-top: auto;
`;

export const LinkButton = styled.a`
    display: inline-flex;
    align-items: center;
    gap: .5rem;

    width: fit-content;

    color: ${({ theme }) => theme.colors.primary};

    text-decoration: none;
    font-weight: 600;

    transition: .3s ease;

    svg {
        transition: transform .3s ease;
    }

    &:hover svg{
        transform: translateX(6px);
    }
`;

export const Video = styled.video`
    width: 100%;
    height: 360px;

    object-fit: cover;

    display: block;

    
    /* Tablets */
    @media (max-width: 1024px) {
        height: 620px;
    }

    @media (max-width: 980px) {
        height: 1019px;
    }

    /* Celuares grandes */
    @media (max-width: 768px) {
        height: 950px;
    }

    @media (max-width: 580px) {
        height: 640px;
    }

    /* Celulares normales */
    @media (max-width: 480px) {
        height: 475px;
    }

    @media (max-width: 390px) {
        height: 443px;
    }

    /* Celulares pequeños */
    @media (max-width: 380px) {
        height: 422px;
    }

    @media (max-width: 350px) {
        height: 382px;
    }
`;